export default __webpack_public_path__ + "static/media/d917998a89bbcd7b.966dfab65dd4e862310051e2946dfec6.svg";